module.exports = __webpack_public_path__ + "static/media/kitapaktivasyonu_ADIM3.4de460df.jpg";